/**
 * Social — legacy route redirect.
 *
 * The "Social" section was split into two focused pages:
 *   * `/social/just-plucking-around` — the LIVE Elfsight #PooPluckers
 *     feed (hero) + follow row + admin-curated gallery.
 *   * `/social/community` — the "coming soon" friendly-community
 *     opt-in copy.
 *
 * The legacy `/social` route resolves here and immediately redirects
 * to the LIVE page (the default landing target — more content, more
 * value). Footer + external links keep pointing at `/social`; the
 * redirect absorbs them so no external caller has to update its
 * bookmark. `replace` is used so the redirect doesn't add a new
 * history entry.
 */
import React from "react";
import { Navigate } from "react-router-dom";

export default function Social() {
  return <Navigate to="/social/just-plucking-around" replace />;
}
